module.exports = "<!-- // TODO: decide what to do about the max-width of these -->\r\n<a>\r\n  <div class=\"well dashboard-tile-container\">\r\n      <div class=\"tile\">\r\n        <div class=\"tile-image-container\" [ngStyle]=\"{backgroundImage : 'url(' + image + ')'}\"></div>\r\n          <div class=\"btn btn-primary btn-block dashboard-tile-button\">\r\n            {{title}}\r\n          </div>\r\n      </div>\r\n  </div>\r\n</a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/components/tile/dashboard-tile.component.html
// module id = ./src/app/dashboard/components/tile/dashboard-tile.component.html
// module chunks = main